import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {MemberService} from "../../service/member/member.service";
import {PrintHistoryItem} from "../../service/member/member";
import * as moment from "moment";

@Component({
  selector: 'app-printing-board',
  templateUrl: './printing-board.component.html',
  styleUrls: ['./printing-board.component.scss'],
  providers: [MemberService]
})
export class PrintingBoardComponent {
  history: any = {};

  page: number;
  startTime: string;
  endTime: string;

  constructor(private memberService: MemberService,
              private router: Router,
              private route: ActivatedRoute,)
  {
    this.route.queryParams.subscribe(
      params => {
        this.page      = params['page']       ? +params['page']     : 1;
        this.sort      = params['sort']       ? params['sort']     : '';
        this.type      = params['type']       ? params['type']     : '';
        this.startTime = params['startTime']  ? params['startTime'] : moment().subtract(1, 'month').format('YYYY-MM-DD');
        this.endTime   = params['endTime']    ? params['endTime']   : moment().format('YYYY-MM-DD');
        this.active    = params['startTime'] && params['endTime'] ?
          moment(this.endTime, 'YYYY-MM-DD').diff(moment(this.startTime, 'YYYY-MM-DD'), 'month')+'' : '1';

        this.getHistory();
      }
    );
  }

  getHistory() {
    this.memberService.getPrintHistory(this.page, this.startTime, this.endTime).subscribe(
      res => this.history = res
    )
  }

  reload() {
    let url = this.router.url.split('?')[0];
    this.router.navigateByUrl(
      `${url}?` +
      (this.page ? `page=${this.page}` : '') +
      (this.sort ? `&sort=${this.sort}` : '') +
      (this.startTime ? `&startTime=${this.startTime}` : '') +
      (this.endTime ? `&endTime=${this.endTime}` : '')
    );
  }

  onSearch() {
    this.active = moment(this.endTime, 'YYYY-MM-DD').diff(moment(this.startTime, 'YYYY-MM-DD'), 'month')+'';
    this.reload();
  }

  active: string;
  onActive(active: string) {
    this.active = active;

    if(active === '1') {
      this.startTime = moment().subtract(1, 'month').format('YYYY-MM-DD');
      this.endTime   = moment().format('YYYY-MM-DD');
    }
    else if(active === '2') {
      this.startTime = moment().subtract(2, 'month').format('YYYY-MM-DD');
      this.endTime   = moment().format('YYYY-MM-DD');
    }
    else if(active === '6') {
      this.startTime = moment().subtract(6, 'month').format('YYYY-MM-DD');
      this.endTime   = moment().format('YYYY-MM-DD');
    }

    this.reload();
  }

  sort: string;
  onSort(sort: string) {
    this.sort = sort
    this.reload();
  }

  type: string;
  onType(type: string) {
    this.type = type
    this.reload();
  }

  onPageChanged(event: any) {
    if (event.page == this.page) return;

    this.page = event.page;
    this.reload();
  }

  convTime(txt) {
    return `${txt.substr(0,2)}:${txt.substr(2,2)}:${txt.substr(4,2)}`
  }
}



// WEBPACK FOOTER //
// ./src/app/member/printing-board/printing-board.component.ts